import { combineReducers } from 'redux';
import { Loadable, Reducer } from '../../../types';
import { OrderAction } from '../types';
import { Order } from '../../../../types/items';
import {
  createOrderFail,
  createOrderRequest,
  createOrderSuccess,
  createVideoEditOrderRequest,
  saveVideoEditOrderRequest,
  getOrderFail,
  getOrderListRequest,
  getOrderRequest,
  getOrderSuccess,
  initOrderFail,
  initOrderRequest,
  initOrderSuccess,
  resetCurrentOrder,
  saveOrderFail,
  saveOrderRequest,
  saveOrderSuccess,
} from '../actions';

type State = Loadable<Order>;
type ReducerOf<T extends keyof State> = Reducer<State, OrderAction, T>;

const data: ReducerOf<'data'> = (state = null, action) => {
  switch (action.type) {
    case resetCurrentOrder.type:
    case getOrderListRequest.type:
    case initOrderRequest.type:
      return null;

    case getOrderSuccess.type:
    case createOrderSuccess.type:
    case saveOrderSuccess.type:
    case initOrderSuccess.type:
      return action.payload;

    default:
      return state;
  }
};

const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case getOrderRequest.type:
    case createOrderRequest.type:
    case saveOrderRequest.type:
    case initOrderRequest.type:
    case createVideoEditOrderRequest.type:
    case saveVideoEditOrderRequest.type:
      return true;

    case getOrderSuccess.type:
    case getOrderFail.type:
    case createOrderSuccess.type:
    case createOrderFail.type:
    case saveOrderSuccess.type:
    case saveOrderFail.type:
    case initOrderSuccess.type:
    case initOrderFail.type:
      return false;

    default:
      return state;
  }
};


export default combineReducers<State>({
  data,
  loading,
});
